import photo1 from "../../../../assets/labPhotos/main/mainPhoto1.jpg"
import photo2 from "../../../../assets/labPhotos/main/mainPhoto2.jpg"


export const mainPhotos = [
  { srcSmall: photo1, alt: "Photo 1" },
  { srcSmall: photo2, alt: "Photo 2" },
]